module.exports = __webpack_public_path__ + "static/media/accessory29.bbb30750.webp";